<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>

        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Monthly Summary
                </v-card-title>
                <v-tabs fixed-tabs v-model="tab">
                    <v-tab  :key="1">
                        Energy/Faults
                    </v-tab>
                    <v-tab  :key="2">
                        Chiller Plant Performance
                    </v-tab>

                    <v-tab  :key="3">
                        Export
                    </v-tab>

                    <v-tab-item  :key="1">
                        <v-layout row wrap>
                            <v-flex xs12 md6>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <vue-plotly disable-responsive :data="energyData" :layout="energyLayout" :options="{}"/>
                                    </v-flex>
                                    <v-flex xs12>
                                        <vue-plotly disable-responsive :data="energyWeatherData" :layout="energyWeatherLayout" :options="{}"/>
                                    </v-flex>
                                    <v-flex xs8 class="pl-5">
                                        <v-data-table
                                                :headers="headers"
                                                :items="tablevals"
                                                class="elevation-1"
                                                hide-actions
                                        >
                                            <template v-slot:items="props">
                                                <td>
                                                    {{ props.item.t1 }}<br/>
                                                    {{ props.item.t2 }}
                                                </td>
                                                <td>
                                                    {{ props.item.e1 }}<br/>
                                                    {{ props.item.e2 }}
                                                </td>
                                                <td v-show="props.item.change " class="text-xs-right" v-bind:class="{ 'green-thing green-icon': props.item.change<=0 }">{{ props.item.change }} %
                                                    <v-icon v-show="props.item.change<=0">fa-long-arrow-alt-down</v-icon>
                                                    <v-icon v-show="props.item.change>0">fa-long-arrow-alt-up</v-icon>
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                    <v-flex xs4>
                                        <p class="headline ml-4">Energy Consumption</p>
                                        <p class="headline ml-4" v-bind:class="{ 'green-thing green-icon': powerDiffValue<=0 }">{{powerDiffValue.toFixed(2)}} kWh
                                            <v-icon v-show="powerDiffValue<=0">fa-long-arrow-alt-down</v-icon>
                                            <v-icon v-show="powerDiffValue>0">fa-long-arrow-alt-up</v-icon>
                                        </p>
                                        <p class="headline ml-4" v-bind:class="{ 'green-thing green-icon': powerDiff<=0 }">{{powerDiff.toFixed(2)}} %
                                            <v-icon v-show="powerDiff<=0">fa-long-arrow-alt-down</v-icon>
                                            <v-icon v-show="powerDiff>0">fa-long-arrow-alt-up</v-icon>
                                        </p>
                                    </v-flex>
                                    <v-flex xs12 class="pa-5">
                                        <v-textarea solo box flat auto-grow v-model="comment1"></v-textarea>
                                    </v-flex>
                                </v-layout>

                            </v-flex>
                            <v-flex xs12 md6>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <vue-plotly disable-responsive :data="energyPieData" :layout="energyPieLayout"
                                                    :options="{}"/>
                                    </v-flex>
                                    <v-flex xs12>
                                        <vue-plotly disable-responsive :data="energyCategoryData" :layout="energyCategoryLayout"
                                                    :options="{}"/>
                                    </v-flex>

                                    <v-flex xs6>
                                        <vue-plotly v-if="faultPieData1" disable-responsive
                                                    :data="faultPieData1" :layout="faultPieLayout1"
                                                    @click="jumpToNotification($event,'severity')"
                                                    :options="{}"/>
                                    </v-flex>
                                    <v-flex xs6>
                                        <vue-plotly v-if="fddRepData"
                                                    disable-responsive  :data="fddRepData"
                                                    @click="jumpToNotification($event,'severity')"
                                                    :layout="fddRepLayout"  :options="{}" ref="plotly"/>
                                    </v-flex>
                                    <v-flex xs6>
                                        <p class="subheading ml-5">FDD Costs</p>
                                        <p class="subheading ml-5" v-if="fddCost">{{fddCost.toFixed(2)}}</p>
                                    </v-flex>
                                    <v-flex xs6>
                                        <p class="subheading ml-5">Acknowledged : {{ackFault}}</p>
                                        <p class="subheading ml-5">Unacknowledged : {{unackFault}}</p>
                                        <p class="subheading ml-5">Total : {{totalFault}}</p>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-tab-item>
                    <v-tab-item :key="2">
                        <v-layout row wrap v-if="tab===1">
                            <v-flex xs12 md6>
                                <v-layout row wrap v-if="chillerCOP">
                                    <v-flex xs4 v-if="plantCOP"></v-flex>
                                    <v-flex xs4 class="pa-2" v-if="plantCOP">
                                        <VueSvgGauge
                                                :start-angle="-110"
                                                :end-angle="110"
                                                :value="plantCOP"
                                                :separator-step="2"
                                                :min="0"
                                                :max="6"
                                                :gauge-color="[{ offset: 0, color: '#F25D27'}, { offset: 30, color: '#F28705'},{ offset: 60, color: '#77C16B'}]"
                                                :scale-interval="0.1"
                                        >
                                            <div class="inner-text2">
                                                <span>Plant COP<br> (chiller only)<br>  <strong>{{plantCOP.toFixed(2)}}</strong></span>
                                            </div>
                                        </VueSvgGauge>
                                    </v-flex>
                                    <v-flex xs4 v-if="plantCOP"></v-flex>
                                    <v-flex xs3 class="pa-2" v-for="chiller in chillerCOP">
                                        <VueSvgGauge
                                                :start-angle="-110"
                                                :end-angle="110"
                                                :value="chiller.cop"
                                                :separator-step="2"
                                                :min="0"
                                                :max="6"
                                                :gauge-color="[{ offset: 0, color: '#F25D27'}, { offset: 30, color: '#F28705'},{ offset: 60, color: '#77C16B'}]"
                                                :scale-interval="0.1"
                                        >
                                            <div class="inner-text">
                                                <span>{{chiller.name}} COP <strong>{{chiller.cop.toFixed(2)}}</strong></span>
                                            </div>
                                        </VueSvgGauge>
                                    </v-flex>

                                </v-layout>

                            </v-flex>
                            <v-flex xs12 md6>
                                <vue-plotly v-if="chillersOnData" disable-responsive :data="chillersOnData" :layout="chillersOnLayout" :options="{}"/>
                                <div class="pr-5 pl-5"><v-textarea solo box flat auto-grow v-model="comment2"></v-textarea></div>
                            </v-flex>
                            <v-flex v-for="plot in plotList" :key="'ms'+plot.id"  xs12 md6 >
                                <cop-plot v-if="plot.type==='cop'" ref="plots"
                                          :variable-x="plot.config['variable-x']"
                                          :variable-y="plot.config['variable-y']"
                                          :facility_name="facility_name"
                                          :date-range="plot.config['range'] ? plot.config['range'] : dateRange"
                                          :layout-overrides="plot.config['layout-overrides']"
                                          :extra-vars="plot.config['extra-vars']"
                                          :type="plot.config['type']"
                                          :mode="plot.config['mode']"
                                          just-plot
                                ></cop-plot>
                                <multi-plot-chart ref="plots" v-if="plot.type==='multi-chart'"
                                                  :date-range="plot.config['range'] ? plot.config['range'] : dateRange"
                                                  :variable-x="plot.config['variable-x']"
                                                  :variables-list="plot.config['variables-list']"
                                                  :layout-overrides="plot.config['layout-overrides']"
                                                  :type="plot.config['type']"
                                                  just-plot
                                ></multi-plot-chart>
                            </v-flex>


                        </v-layout>
                    </v-tab-item>
                    <v-tab-item :key="3">
                        <v-layout row wrap v-if="showExportTab">
                            <v-flex xs12 style="page-break-inside: avoid !important;">
                                <vue-plotly v-if="euGroupedData" disable-responsive :data="euGroupedData" :layout="euGroupedLayout" :options="{}"/>
                            </v-flex>
                            <v-flex xs6 style="page-break-inside: avoid !important;">
                                <vue-plotly v-if="eu2020StackData" disable-responsive :data="eu2020StackData" :layout="eu2020StackLayout" :options="{}"/>
                            </v-flex>
                            <v-flex xs6 style="page-break-inside: avoid !important;">
                                <vue-plotly v-if="eu2019StackData" disable-responsive :data="eu2019StackData" :layout="eu2019StackLayout" :options="{}"/>
                            </v-flex>
                            <v-flex xs12 class="pa-5">
                                <v-textarea solo box flat auto-grow v-model="comment3"></v-textarea>
                            </v-flex>
                            <v-flex xs12 style="page-break-inside: avoid !important;">
                                <vue-plotly v-if="eiData" disable-responsive :data="eiData" :layout="eiLayout" :options="{}"/>
                            </v-flex>
                            <v-flex v-for="plot in plotList2" :key="'ms'+plot.id"  xs12>
                                <cop-plot v-if="plot.type==='cop'" ref="plots"
                                          :variable-x="plot.config['variable-x']"
                                          :variable-y="plot.config['variable-y']"
                                          :facility_name="facility_name"
                                          :date-range="plot.config['range'] ? plot.config['range'] : dateRange"
                                          :layout-overrides="plot.config['layout-overrides']"
                                          :extra-vars="plot.config['extra-vars']"
                                          :type="plot.config['type']"
                                          :mode="plot.config['mode']"
                                          just-plot
                                ></cop-plot>
                                <multi-plot-chart ref="plots" v-if="plot.type==='multi-chart'"
                                                  :date-range="plot.config['range'] ? plot.config['range'] : dateRange"
                                                  :variable-x="plot.config['variable-x']"
                                                  :variables-list="plot.config['variables-list']"
                                                  :layout-overrides="plot.config['layout-overrides']"
                                                  :type="plot.config['type']"
                                                  just-plot
                                ></multi-plot-chart>
                            </v-flex>
                            <v-flex xs12 style="page-break-inside: avoid !important;">
                                <vue-plotly v-if="chillersOnData2" disable-responsive :data="chillersOnData2" :layout="chillersOnLayout2" :options="{}"/>
                            </v-flex>



                        </v-layout>
                        <v-layout row wrap v-if="tab===2&&!loading">
                            <v-spacer></v-spacer>
                            <v-btn
                                    flat
                                    @click="printReport()"
                            >
                                <v-icon class="mr-2">fa-print</v-icon>
                                Print
                            </v-btn>
                        </v-layout>
                    </v-tab-item>
                </v-tabs>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {callAPI,getNotification,getIssueSummary} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import moment from 'moment'
    import MultiPlotChart from "../components/MultiPlotChart"
    import CopPlot from "../components/CopPlot";

    import { VueSvgGauge } from 'vue-svg-gauge'

    export default {
        name: 'MonthlySummary',
        components: {VuePlotly,MultiPlotChart,CopPlot,VueSvgGauge},
        computed: {
            plotList(){
                return [
                    {
                        'id': 8,
                        'type': 'cop',
                        'config': {
                            'layout-overrides': {
                                "title":"Plant COP (chiller only)",
                                xaxis: {
                                    title: "Time "
                                },
                                yaxis: {title: 'COP'},
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },

                            },
                            'variable-x': 'timestamp',
                            'variable-y': 'COP',
                            'type': 'scatter',
                        }
                    },
                    {
                        'id': 77,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                "title":"Chiller COP",
                                xaxis: {
                                    title: "Time "
                                },
                                yaxis: {title: 'COP'},
                                yaxis2: {
                                    title: 'Outdoor Temperature (°C)',
                                    overlaying: 'y',
                                    showgrid:false,
                                    side: 'right'
                                },
                                legend: {
                                    orientation: 'h',
                                    y:-0.3
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },


                            },
                            type: 'scatter',
                            'variables-list':[
                                {
                                    equipment_name: "Weather",
                                    facility_name: this.facility_name,
                                    yaxis: 'y2',
                                    name: "Outdoor_Temperature",
                                },
                                ...this.chillers.map(equip=>{
                                    return ({
                                        equipment_name: equip,
                                        facility_name: this.facility_name,
                                        on_only:true,
                                        name: "COP",
                                    })
                                })],

                        }
                    },
                    {
                        'id': 7777,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                "title":"Chiller COP vs Cooling Load",
                                xaxis: {
                                    title: "Cooling Load (Ton)"
                                },
                                yaxis: {title: 'COP'},
                                legend: {
                                    orientation: 'h',
                                    y:-0.3
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },

                            },
                            type: 'scatter',
                            'variables-list':[
                                ...this.chillers.map(equip=>{
                                    return ({
                                        equipment_name: equip,
                                        facility_name: this.facility_name,
                                        name: "COP",
                                        mode: "markers",
                                        on_only:true,
                                        variableX: "Cooling_Load"
                                    })
                                })],

                        }
                    },
                    {
                        'id': 7,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                title:"Energy Consumption",
                                xaxis: {
                                    title: "Time (daily)"
                                },
                                yaxis: {title: 'Energy Consumption (kWh)'},

                                barmode: 'stack',
                                legend: {
                                    orientation: 'h',
                                    y:-0.3
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },
                            },
                            type: 'bar',
                            'variables-list':[
                                ...this.chillers.map(equip=>{
                                    return ({
                                        equipment_name: equip,
                                        facility_name: this.facility_name,
                                        type: 'bar',
                                        agg:{agg:'D',agg_op:'sum'},
                                        name: "Power",
                                    })
                                })
                            ]


                        }
                    },
                    {
                        'id': 9,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                title:"Cooling Load",
                                xaxis: {
                                    title: "Time "
                                },
                                yaxis: {title: 'Cooling Load (kW)'},
                                yaxis2: {
                                    title: 'Outdoor Temperature (°C)',
                                    overlaying: 'y',
                                    showgrid:false,
                                    side: 'right'
                                },
                                legend: {
                                    orientation: 'h',
                                    y:-0.3
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },
                            },
                            type: 'scatter',
                            'variables-list':[
                                {
                                    equipment_name: "Weather",
                                    facility_name: this.facility_name,
                                    yaxis: 'y2',
                                    name: "Outdoor_Temperature",
                                },
                                ...this.chillers.map(equip=>{
                                    return ({
                                        equipment_name: equip,
                                        facility_name: this.facility_name,
                                        stackgroup: 'one',
                                        mode: 'none',
                                        name: "Cooling_Load",
                                    })
                                })],

                        }
                    },
                    {
                        'id': 83,
                        'type': 'cop',
                        'config': {
                            'layout-overrides': {
                                title:"Plant COP (chiller only) vs Outdoor Temperature",
                                xaxis: {
                                    title: "Outdoor Temperature (°C)"
                                },
                                yaxis: {
                                    title: "Plant COP (chiller only)"
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },
                            },
                            'variable-x': 'Outdoor_Temperature',
                            'variable-y': 'COP',
                            'mode': 'markers',
                            'type': 'scatter',
                            'extra-vars': [
                                {
                                    'equipment_name': 'Weather',
                                    'sensor_names': ['Outdoor_Temperature']
                                }
                            ]
                        }
                    },
                    {
                        'id': 36,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                title:"Header Main Supply Temperature vs Outdoor Temperature",
                                xaxis: {
                                    title: "Outdoor Temp (°C)"
                                },
                                yaxis: {
                                    title: "Header Main Supply Temperature (°C)"
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },
                            },
                            'variables-list': [
                                {
                                    equipment_name: "Weather",
                                    facility_name: this.facility_name,
                                    mode: "markers",
                                    name: "Outdoor_Temperature",
                                    useAsXVariable: true
                                },
                                {
                                    equipment_name: "Chilled_Water_Header",
                                    facility_name: this.facility_name,
                                    mode: "markers",
                                    name: "Header_Supply_Temperature",
                                    useXAsHover: true
                                }

                            ],
                            'type': 'scattergl',
                        }
                    },
                    {
                        'id': 54,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                title:"Chilled Water Delta Temp",
                                xaxis: {
                                    title: "Time "
                                },
                                yaxis: {
                                    title: "Temperature Diff (°C)"
                                },
                                legend: {
                                    orientation: 'h',
                                    y:-0.3
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },
                            },
                            'variables-list': [
                                {
                                    equipment_name: "Chilled_Water_Header",
                                    facility_name: this.facility_name,
                                    name: "Header_Supply_Temperature",
                                },
                                {
                                    equipment_name: "Chilled_Water_Header",
                                    facility_name: this.facility_name,
                                    name: "Header_Return_Temperature",
                                }
                            ],
                        }
                    },
                ]
            },
            plotList2(){
                return [
                    {
                        'id': 64446,
                        'type': 'multi-chart',
                        'config': {
                            'layout-overrides': {
                                "title": this.facility_name+" Chiller COP vs Cooling Load Ton ("+moment(this.endDate).format('MMMM')+" "+moment(this.endDate).year()+")",
                                xaxis: {
                                    title: "Cooling Load (Ton)"
                                },
                                yaxis: {title: 'COP'},
                                height:600,
                                legend: {
                                    orientation: 'h',
                                    x:0.5,
                                    y:-0.3,
                                    xanchor:'center'
                                }
                            },
                            type: 'scatter',
                            'variables-list':[
                                ...this.chillers.map(equip=>{
                                    return ({
                                        equipment_name: equip,
                                        facility_name: this.facility_name,
                                        name: "COP",
                                        mode: "markers",
                                        on_only:true,
                                        variableX: "Cooling_Load"
                                    })
                                })],

                        }
                    },
                ]
            },
            facility_name() {
                return this.$store.state.pointsListStore.pointsList.facility_name;
            },
            tablevals(){
                return[
                    {
                        t1:"Current",
                        t2:"Baseline",
                        e1:this.totalPowerSum.toFixed(2),
                        e2:this.pastTotalPowerSum.toFixed(2),
                        change:this.powerDiff.toFixed(2)
                    },
                    {
                        t1:"YTD this year",
                        t2:"YTD last year",
                    }
                ]
            },
            eiData(){
                return[
                {
                    x:[18.1,20.1,21,24.7,25.3,29,29.5,29,28.7,26.6,23,19.1],
                    y:[29.58,30.15,30.30,38.20,41.82,50.05,52.23,53.49,52.02,45.09,37.47,30.29],
                    name:"Electricity Index 2019",
                    mode: 'markers',
                },{
                    x:[18.6,18.5],
                    y:[29.42,27.85],
                    name:"Electricity Index 2020",
                    mode: 'markers',
                },
            ]},
            eiLayout(){
                return{
                    title:this.facility_name+" - Year 2019, 2020 Electricity Index (MVAC) vs Temp",
                    legend: {
                        orientation: 'h',
                        x:0.5,
                        y:-0.3,
                        xanchor:'center'
                    },
                    xaxis:{
                        title:"(°C)"
                    },
                    yaxis:{
                        title:"MJ/sq. m"
                    }

                }
            },
            eu2019StackLayout(){return{
                title:this.facility_name+" - Electricity Usage Index Breakdown 2019",

                legend: {
                    orientation: 'h',
                    x:0.5,
                    y:-0.3,
                    xanchor:'center'
                },
                height:700,

                yaxis:{
                    title:"MJ/sq. m",
                    range:[0,100]
                },
                yaxis2: {
                    title: '(°C)',
                    overlaying: 'y',
                    showgrid:false,
                    rangemode: 'tozero',
                    side: 'right'
                },
                barmode: 'stack'
            }},
            eu2020StackLayout(){return{
                title:this.facility_name+" - Electricity Usage Index Breakdown 2020",

                legend: {
                    orientation: 'h',
                    x:0.5,
                    y:-0.3,
                    xanchor:'center'
                },
                height:700,

                yaxis:{
                    title:"MJ/sq. m",
                    range:[0,100]
                },
                yaxis2: {
                    title: '(°C)',
                    overlaying: 'y',
                    showgrid:false,
                    rangemode: 'tozero',
                    side: 'right'
                },
                barmode: 'stack'
            }},
            euGroupedLayout(){
                return{
                    title:this.facility_name+" - Electricity Usage Index Comparison: 2020 vs 2019",
                    legend: {
                        orientation: 'h',
                        x:0.5,
                        y:-0.3,
                        xanchor:'center'
                    },
                    height:700,

                    yaxis:{
                        title:"MJ/sq. m",
                        range:[0,100]
                    },
                    yaxis2: {
                        title: '(°C)',
                        overlaying: 'y',
                        showgrid:false,
                        rangemode: 'tozero',
                        side: 'right'
                    }

                }
            },
            euGroupedData(){
                let months=[ "January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December" ];
                let monthsCut=[ "January", "February"];
                return [
                    {
                        x:months,
                        y:[48.5,49,47,60,63,72,76,78,75,67,58,49],
                        name:"Energy 2020",
                        type: 'bar',
                    },
                    {
                        x:monthsCut,
                        y:[49,46],
                        name:"Energy 2019",
                        type: 'bar',
                    },
                    {
                        x:months,
                        y:[18.1,20.1,21,24.7,25.3,29,29.5,29,28.7,26.6,23,19.1],
                        yaxis: 'y2',
                        name:"Outdoor Temperature (2019)",
                        type: 'lines',
                        mode:'markers',
                    },
                    {
                        x:monthsCut,
                        y:[18.6,18.5],
                        yaxis: 'y2',
                        name:"Outdoor Temperature (2020)",
                        type: 'lines',
                        mode:'markers',
                    },
                ]
            },
            eu2019StackData(){
                let months=[ "January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December" ];
                return [
                    {
                        x:months,
                        y:[8.18,9.06,10.24,15.42,18.40,25.09,27.17,27.97,26.65,21.78,15.04,9.25],
                        name:"Air conditioning - Water side (2019)",
                        type: 'bar',
                    },{
                        x:months,
                        y:[18.27,18.01,17.33,19.77,20.42,21.83,22.03,22.21,22.06,20.32,19.35,17.96],
                        name:"Air conditioning - Air side (2019)",
                        type: 'bar',
                    },
                    {
                        x:months,
                        y:[3.14,3.08,2.73,3.01,2.99,3.13,3.03,3.31,3.31,3.00,3.08,3.08],
                        name:"Seawater (ES PH) 2019",
                        type: 'bar',
                    },
                    {
                        x:months,
                        y:[13.67,13.08,12.19,13.26,12.47,13.28,13.19,13.03,13.42,12.34,12.43,12.61],
                        name:"Building Services (2019)",
                        type: 'bar',
                    },
                    {
                        x:months,
                        y:[18.1,20.1,21,24.7,25.3,29,29.5,29,28.7,26.6,23,19.1],
                        yaxis: 'y2',
                        name:"Outdoor Temperature (2019)",
                        type: 'lines',
                        mode:'markers',
                    },
                ]
            },
            eu2020StackData(){
                let months=[ "January", "February" ];
                return [
                    {
                        x:months,
                        y:[8.0,6.64],
                        name:"Air conditioning - Water side (2020)",
                        type: 'bar',
                    },{
                        x:months,
                        y:[18.36,18.38],
                        name:"Air conditioning - Air side (2020)",
                        type: 'bar',
                    },
                    {
                        x:months,
                        y:[3.06,2.82],
                        name:"Seawater (ES PH) 2020",
                        type: 'bar',
                    },
                    {
                        x:months,
                        y:[12.09,11.28],
                        name:"Building Services (2020)",
                        type: 'bar',
                    },
                    {
                        x:months,
                        y:[18.6,18.5],
                        yaxis: 'y2',
                        name:"Outdoor Temperature (2020)",
                        type: 'lines',
                        mode:'markers',
                    },
                ]
            }
        },
        data () {
            return {
                headers: [
                    {
                        text: ' ',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    {
                        text: 'Energy (kWh)',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    {
                        text: 'Change',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                ],
                tab:0,
                comment1:"Analysis",
                severityColors:{
                    critical:'rgb(148, 103, 189)',
                    low:'rgb(188, 189, 34)',
                    medium:'rgb(255, 127, 14)',
                    high:'rgb(214, 39, 40)',
                },
                comment2:"Analysis",
                comment3:"February 2020 was much warmer than usual in Hong Kong. The monthly mean temperature " +
                    "was 18.5 degrees, which was 1.7 degree above the normal figure, and it is the eighth highest " +
                    "on record for February.\n" +
                    "However, compared to 2019 which recorded 21.1 degrees, a noticeable reduction in cooling " +
                    "load thus energy reduction of water-side energy consumption is noticed in February 2020. " +
                    "Although there is an increase in air-side consumption due to the implementation of 24-hour " +
                    "PAU operation due to the COVID-19 situation. The reduction is water-side is more significant " +
                    "compared to air-side increase.\n" +
                    "In the meantime, the outbreak of COVID-19 which has much reduced the occupancy of our " +
                    "buildings. Together, we have seen a large reduction in building services energy consumption " +
                    "and AC usage which compare with year 2019. \n" +
                    "The following measures have been adopted in order to achieve saving, " +
                    "1) Minimising the primary air handling units (PAUs) by 2 hours during weekdays for office " +
                    "floors and by 6 hours during Saturday to reduce energy consumption.\n" +
                    "2) PAUs stop running during lunch time in weekdays, to be started in mid-October 2017\n" +
                    "3) The implementation of upgrade projects in Exchange Square, including LED lighting" +
                    "upgrade, chiller replacement and lift modernisation\n" +
                    "4) Installation of new LED tubes instead of existing cold cathode lamps at 1/F footbridges " +
                    "in podium.\n" +
                    "The normalised electricity usage index (EUI) is shown as below. Note that the outdoor " +
                    "temperature is based on HKO monthly average weather data.\n" +
                    "Comparing with Jan 2018 and Jan 2019, Jan 2019 recorded an average outdoor temperature " +
                    "increase of 2°C. This has increased the chillers loading thus led to the increase of total energy. " +
                    "consumption of Exchange Square in Jan 2019 compared to Jan 2018.",
                baseDate:  moment().subtract(8, "days"),
                endDate:  moment().subtract(1, "days"),
                plantCOP:null,
                dateRange:  {start:moment().subtract(8, "days").format("YYYY-MM-DD"),end:moment().subtract(1, "days").format("YYYY-MM-DD")},
                loading:true,
                energyData:null,
                chillers:null,
                energyPieData:null,
                energyCategoryData:null,
                chillerCOP:null,
                faultPieData1:null,
                fddRepData:null,
                energyWeatherData:null,
                totalFault:null,
                unackFault:null,
                ackFault:null,
                fddCost:null,
                showExportTab:false,
                chillersOnData:null,
                totalPowerSum:null,
                pastTotalPowerSum:null,
                powerDiff:null,
                powerDiffValue:null,
                energyLayout:{
                    title:"Energy Consumption VS Baseline",
                    legend: {
                        orientation: 'h',
                        x: 0,
                        y: 1.1
                    },
                    yaxis: {
                        title: 'Energy (kWh)'
                    },
                    xaxis: {
                        title: 'Time (daily)'
                    }
                },
                energyWeatherLayout:{
                    title:"Energy Consumption Comparison Summary",
                    legend: {
                        orientation: 'h',
                        x: 0,
                        y: 1.1
                    },
                    yaxis: {
                        title: 'Energy (kWh)'
                    },
                    xaxis: {
                        title: 'Time (daily)'
                    },
                    yaxis2: {
                        title: 'Outdoor Temperature (°C)',
                        overlaying: 'y',
                        showgrid:false,
                        rangemode: 'tozero',
                        side: 'right'
                    }
                },
                energyCategoryLayout:{
                    title:"Energy Consumption Profile",
                    legend: {
                        orientation: 'h',
                        x: 0,
                        y: 1.1,
                        traceorder:"normal"
                    },
                    yaxis: {
                        title: 'Energy (kWh)'
                    },
                    xaxis: {
                        title: 'Time (daily)'
                    },
                    barmode: 'stack'
                },
                energyPieLayout:{
                    title:"Energy Consumption Breakdown",
                    legend:{
                        traceorder:"normal"
                    }
                },
                faultPieLayout1:{
                    title:"Fault Severity",
                    legend: {
                        orientation: 'h',
                        x: 0.1,
                    },
                    margin:{
                        l: 20,
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },
                chillersOnLayout:{
                    title:"Chiller Running Hours",
                },chillersOnLayout2:{
                    title:"Chiller Running Hours",
                    height:660,
                    legend: {
                        orientation: 'h',
                        x:0.5,
                        y:-0.3,
                        xanchor:'center'
                    },
                },
                fddRepLayout:{
                    title:"Fault Breakdown",
                    barmode: 'group',
                    legend: {
                        orientation: 'h',
                    },
                    margin:{
                        l: 20,
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },

            }
        },
        watch: {
            tab (newTab ) {
                let me=this
                if(newTab===2){
                    setTimeout(function(){
                        me.showExportTab=true
                    },300)
                } else {
                    this.showExportTab=false
                }
            },

        },
        methods:{
            printReport(){
                window.print()
            },
            jumpToNotification(data,facet) {
                let output = {
                    path: '/notification-breakdown',
                    query:{
                        rangeStart: this.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                        rangeEnd: this.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    }
                }
                output.query[facet]=data.points[0].label
                this.$router.push(output)
            },
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    if(!ar2[i]){
                        ar3.push(ar1[i]);
                    } else {
                        ar3.push(ar1[i] + ar2[i]);
                    }
                return ar3;
            },
            handleDateChange(){
                this.baseDate = moment(this.dateRange.start)
                this.endDate = moment(this.dateRange.end)
                this.getData()
            },
            getData(){
                let me=this;
                me.loading=true
                let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                let pastRange=[moment(currentRange[0]).subtract(1, "week").startOf('day').format('YYYY-MM-DD HH:mm:ss'),moment(currentRange[1]).subtract(1, "week").endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                let promises=[
                    callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': "Weather",
                            'agg': 'D',
                            'agg_op': 'mean',
                            'date_range':currentRange,
                            'sensor_names': ['Outdoor_Temperature']
                        }
                    ),
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'sensor_names': ["Power"],
                                "equipment_type_regex": "^chiller",
                                'date_range': currentRange,
                            },
                            'etCategory': "Chillers",
                            "pipeline": [
                                {"type": "agg_h", "agg_op": "sum"},
                                {"type": "agg", "agg": "D", "agg_op": "sum"}
                            ]
                        }
                    ),
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'sensor_names': ["Power"],
                                "equipment_type_regex": "water_pump$",
                                'date_range': currentRange,
                            },
                            'etCategory': "Pumps",
                            "pipeline": [
                                {"type": "agg_h", "agg_op": "sum"},
                                {"type": "agg", "agg": "D", "agg_op": "sum"}
                            ]
                        }
                    ),
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'sensor_names': ["Power"],
                                'equipment_type_regex': 'ecfan|ahu',
                                'date_range': currentRange,
                            },
                            'etCategory': "AHUs",
                            "pipeline": [
                                {"type": "agg_h", "agg_op": "sum"},
                                {"type": "agg", "agg": "D", "agg_op": "sum"}
                            ]
                        }
                    ),
                ];
                let chillerCOPPromises=[];
                let pastPromises=[];
                let chillers=[];
                pastPromises.push(callAPI('data/',
                    {
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'equipment_name': "Weather",
                        'agg': 'D',
                        'agg_op': 'mean',
                        'date_range':pastRange,
                        'sensor_names': ['Outdoor_Temperature']
                    }
                ))
                pastPromises.push(callAPI('data2/',
                    {
                        'filters': {
                            'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                            'sensor_names': ["Power"],
                            'date_range':pastRange,
                        },
                        "pipeline": [
                            {"type": "agg_h", "agg_op": "sum"},
                            {"type": "agg", "agg": "D", "agg_op": "sum"}
                        ]
                    }
                ))
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type.toLowerCase().startsWith('chiller')){
                        chillers.push(equip.equipment_name)
                        chillerCOPPromises.push(callAPI('data/',
                            {
                                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_name': equip.equipment_name,
                                'agg': 'M',
                                'on_only':true,
                                'agg_op': 'sum',
                                'date_range':currentRange,
                                'sensor_names': ['Cooling_Load','Power']
                            }
                        ))
                    }

                }
                me.chillers=chillers;
                let timestamp=null;
                let currentWeather=null;
                let pastWeather=null;
                let currentPower={
                    "Chillers":null,
                    "Pumps":null,
                    "AHUs":null,
                }
                let currentPowerCategTotals={};
                let currentPowerTotal=null
                callAPI('data2/',
                    {
                        'filters': {
                            'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_type_regex': '^chiller',
                            'sensor_names': ["on"],
                            'date_range':currentRange,
                        },
                        "pipeline": [
                            {"type": "agg", "agg": "D", "agg_op": "sum"}
                        ]
                    }
                ).then(function(result){
                    let chillerNames=[]
                    let chillerOn=[]
                    for (let chillerName of me.chillers) {
                        if(result.data[chillerName+' - on']) {
                            chillerNames.push(chillerName)
                            chillerOn.push(result.data[chillerName + ' - on'].reduce((sum, x) => sum + x) / me.$store.state.pointsListStore.pointsList.sampling_freq)
                        }
                    }
                    me.chillersOnData=[{
                        type: 'pie',
                        hole: .7,
                        labels: chillerNames,
                        values: chillerOn
                    }]
                    me.chillersOnData2=[{
                        type: 'pie',
                        hole: .7,
                        labels: chillerNames,
                        textinfo: "label+value+percent",
                        textposition: "outside",
                        values: chillerOn
                    }]
                    me.chillersOnLayout2.title=me.$store.state.pointsListStore.pointsList.facility_name+
                        " CHILLER RUNNING HOURS ("+moment(me.endDate).format('MMMM')+" "+
                        moment(me.endDate).year()+")"
                })
                Promise.all(promises).then(function (reses) {
                    for (let res of reses) {
                        if(res.data&&res.data['Outdoor_Temperature']){
                            currentWeather=res.data['Outdoor_Temperature']
                        } else {
                            if(res.data['sum']&&res.data['sum'].length>0) {
                                if (!timestamp && res.data.timestamp && res.data.timestamp.length > 0) {
                                    timestamp = res.data.timestamp;
                                }
                                let category = JSON.parse(res.config.data)["etCategory"]
                                let powerForThis = res.data['sum'].map(x => x / me.$store.state.pointsListStore.pointsList.sampling_freq)
                                if (!currentPower[category]) {
                                    currentPower[category] = powerForThis
                                } else {
                                    currentPower[category] = me.addArrays(currentPower[category], powerForThis)
                                }
                            }

                        }

                    }
                    let pieData={
                        type: 'pie',
                        hole: .7,
                        labels: [],
                        values: []
                    }
                    let energyCategoryData=[]
                    for (let category in currentPower){
                        if(currentPower[category]&&currentPower[category].length>0){
                            if(!currentPowerTotal){
                                currentPowerTotal=currentPower[category]
                            } else {
                                currentPowerTotal=me.addArrays(currentPowerTotal,currentPower[category])
                            }
                            currentPowerCategTotals[category]=currentPower[category].reduce((sum, x) => sum + x)
                            pieData.labels.push(category)
                            pieData.values.push(currentPowerCategTotals[category])
                            energyCategoryData.push({
                                x:timestamp,
                                y:currentPower[category],
                                type:'bar',
                                name:category
                            })}

                    }
                    me.energyPieData=[pieData]
                    me.energyCategoryData=energyCategoryData
                    Promise.all(pastPromises).then(function (pastReses) {
                        let pastTotalPower=null
                        for (let pastRes of pastReses) {
                            if(pastRes.data&&pastRes.data['Outdoor_Temperature']){
                                pastWeather=pastRes.data['Outdoor_Temperature']
                            }else {
                                let powerForThis=pastRes.data['sum']
                                powerForThis=powerForThis.map(x=>x/me.$store.state.pointsListStore.pointsList.sampling_freq)
                                if(!pastTotalPower){
                                    pastTotalPower=powerForThis
                                } else {
                                    pastTotalPower=me.addArrays(pastTotalPower,powerForThis)
                                }
                            }


                        }
                        me.energyData=[
                            {x:timestamp,y:currentPowerTotal,name:"Energy",fill: 'tozeroy',fillcolor:"rgba(31, 119, 180,0.5)",mode:"lines",line:{color:"rgba(31, 119, 180,0.5)"}},
                            {x:timestamp,y:pastTotalPower,
                                name:"Baseline ("+moment(pastRange[0]).format('YYYY-MM-DD')+" - "+moment(pastRange[1]).format('YYYY-MM-DD')+")",
                                mode:"lines",
                                line:{color:"rgb(255, 127, 14)"}
                            },
                        ]
                        me.energyWeatherData=[
                            {
                                x:timestamp,
                                y:currentPowerTotal,
                                name:"Energy",
                                type: 'bar',
                            },
                            {
                                x:timestamp,
                                y:pastTotalPower,
                                name:"Baseline ("+moment(pastRange[0]).format('YYYY-MM-DD')+" - "+moment(pastRange[1]).format('YYYY-MM-DD')+")",
                                type: 'bar',
                            },
                            {
                                x:timestamp,
                                y:currentWeather,
                                yaxis: 'y2',
                                name:"Weather",
                                type: 'lines',
                            },
                            {
                                x:timestamp,
                                y:pastWeather,
                                yaxis: 'y2',
                                name:"Baseline Weather",
                                type: 'lines',
                            },
                        ]
                        me.totalPowerSum=currentPowerTotal.reduce((sum, x) => sum + x)
                        me.pastTotalPowerSum=pastTotalPower.reduce((sum, x) => sum + x)
                        me.powerDiff=-((me.pastTotalPowerSum-me.totalPowerSum)/me.pastTotalPowerSum)*100
                        me.powerDiffValue=-(me.pastTotalPowerSum-me.totalPowerSum)
                        me.loading=false
                    })
                })
                getNotification({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range:currentRange,
                }).then(function(notifResult) {
                    let rangeFaults = notifResult.result
                    me.totalFault=rangeFaults.length;
                    me.unackFault=rangeFaults.filter(x=>!x.acknowledged).length;
                    me.ackFault=rangeFaults.filter(x=>!!x.acknowledged).length;
                    let faultSeverity = { }
                    for (let fault of rangeFaults){
                        if(!faultSeverity[fault.severity]){
                            faultSeverity[fault.severity]=1
                        } else {
                            faultSeverity[fault.severity]=faultSeverity[fault.severity]+1
                        }
                    }
                    let faultPieData1={
                        type: 'pie',
                        hole: .7,
                        labels: [],
                        marker: {
                            colors:[],
                        },
                        values: []
                    }

                    for (let severity in faultSeverity){
                        faultPieData1.labels.push(severity)
                        faultPieData1.marker.colors.push(me.severityColors[severity])
                        faultPieData1.values.push(faultSeverity[severity])
                    }
                    let fddRepData=[]
                    let faultsByType={
                        'Chillers':rangeFaults.filter(x=>x.equipment_type.toLowerCase().startsWith('chiller')),
                        'Pumps':rangeFaults.filter(x=>x.equipment_type.toLowerCase().endsWith('water_pump')),
                        'AHUs':rangeFaults.filter(x=>x.equipment_type==="ECFAN"||x.equipment_type==="AHU"),
                        'VAVs':rangeFaults.filter(x=>x.equipment_type==="VAV")
                    }
                    for (let faultType in faultsByType){
                        let part={
                            x:[],
                            y:[],
                            name: faultType,
                            type: 'bar',
                            orientation: 'h'
                        }
                        for (let severity in faultSeverity){
                            part.y.push(severity)
                            part.x.push(faultsByType[faultType].filter(x=>x.severity===severity).length)
                        }
                        fddRepData.push(part)
                    }
                    me.faultPieData1=[faultPieData1];
                    me.fddRepData=fddRepData;
                })

                Promise.all(chillerCOPPromises).then(function (chillerReses) {
                    let chillerCOP=[]
                    for (let chillerRes of chillerReses) {
                        if(chillerRes&&chillerRes.data['Cooling_Load']&&chillerRes.data['Cooling_Load'].length>0){
                            chillerCOP.push({
                                name:JSON.parse(chillerRes.config.data)["equipment_name"],
                                cop:chillerRes.data.Cooling_Load[0]/chillerRes.data.Power[0]
                            });
                        }

                    }
                    me.chillerCOP=chillerCOP;

                })
                callAPI('cop/',{
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    from_date: currentRange[0],
                    to_date: currentRange[1],
                    agg: 'M',
                    agg_op: 'sum',
                }).then(function(mainCOPRes){
                    if(mainCOPRes.data.COP){
                        me.plantCOP=mainCOPRes.data.Cooling_Load[0]/mainCOPRes.data.power[0]
                    }
                })
                getIssueSummary({
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment_name': null,
                    'date_range': {start:currentRange[0],end:currentRange[1]}
                }).then(function(issues){
                    me.fddCost=issues.summary.reduce(function (acc, obj) { return acc + obj.cost; }, 0)
                })

            }

        },
        beforeMount() {
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDate){
                this.baseDate=moment(maxDate).subtract(8, "days")
                this.endDate=moment(maxDate).subtract(1, "days")
                this.dateRange={start:this.baseDate.format('YYYY-MM-DD'),end:this.endDate.format('YYYY-MM-DD')}
            }
            this.getData();
        }



    }
</script>
<style>
    .green-icon .theme--light.v-icon{
        color: #77C16B;
    }
    .green-icon .theme--dark.v-icon{
        color: #77C16B;
    }
    .green-thing{
        color: #77C16B;
    }
    .inner-text{
        margin-right: auto;
        margin-top: 80px;
        width: 100px;
        text-align: center;
        margin-left: auto;
    }
    .inner-text2{
        margin-right: auto;
        margin-top: 60px;
        width: 100px;
        font-size: 12px;
        text-align: center;
        margin-left: auto;
    }
</style>
